import { S as getContext, O as setContext, Q as spread_props, R as bind_props, P as pop, N as push } from "./index.js";
import { o as onDestroy } from "./index-server.js";
import { c as classMap, S as SmuiElement } from "./SmuiElement.js";
import "clsx";
function ClassAdder($$payload, $$props) {
  push();
  let {
    use = [],
    class: className = "",
    component: MyComponent = SmuiElement,
    tag = "div",
    _smuiClass = "",
    _smuiClassMap = {},
    _smuiContexts = {},
    _smuiProps = {},
    children,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  let element;
  const smuiClassUnsubscribes = [];
  Object.entries(_smuiClassMap).forEach(([name, context]) => {
    const store = getContext(context);
    if (store && "subscribe" in store) {
      smuiClassUnsubscribes.push(store.subscribe((value) => {
        _smuiClassMap[name] = value;
      }));
    }
  });
  for (let context in _smuiContexts) {
    if (_smuiContexts.hasOwnProperty(context)) {
      setContext(context, _smuiContexts[context]);
    }
  }
  onDestroy(() => {
    for (const unsubscribe of smuiClassUnsubscribes) {
      unsubscribe();
    }
  });
  function getElement() {
    return element.getElement();
  }
  $$payload.out += `<!---->`;
  MyComponent($$payload, spread_props([
    {
      tag,
      use,
      class: classMap({
        [className]: true,
        [_smuiClass]: true,
        ..._smuiClassMap
      })
    },
    _smuiProps,
    restProps,
    {
      children: ($$payload2) => {
        children?.($$payload2);
        $$payload2.out += `<!---->`;
      },
      $$slots: { default: true }
    }
  ]));
  $$payload.out += `<!---->`;
  bind_props($$props, { getElement });
  pop();
}
export {
  ClassAdder as C
};
